const WorkExperience = [
  {
    id: 1,
    title: "React Native Developer",
    company: "Target",
    yearsActive: "Jan 2024 - Current",
    information: [
      "Developed and published a comprehensive education app for GATE exam preparation on Google Play Store",
      "Implemented user-friendly UI/UX for seamless study experience",
      "Integrated Firebase for backend services and real-time data synchronization",
    ],
  },
  {
    id: 4,
    title: "Frontend Developer",
    company: "Game Website",
    yearsActive: "Sep 2023 - Dec 2023",
    information: [
      "Built a sleek and interactive website for the Pikachu Game project",
      "Implemented responsive layouts and animations for engaging user experience",
      "Collaborated with designers and backend developers to ensure smooth performance",
    ],
  },
  {
    id: 5,
    title: "UX Designer",
    company: "ByteTrackReality",
    yearsActive: "Mar 2023 - Aug 2023",
    information: [
      "Redesigned the real estate agency website with modern UI and improved UX flow",
      "Collaborated with developers to implement responsive and interactive components",
      "Created detailed wireframes and prototypes using Figma",
    ],
  },
  {
    id: 2,
    title: "UI Designer",
    company: "Butterfly",
    yearsActive: "Jan 2023 - Feb 2023",
    information: [
      "Designed the landing page for a real estate website with a focus on aesthetics and user engagement",
      "Created wireframes, mockups, and prototypes using Figma",
      "Worked closely with developers to ensure accurate implementation of design",
    ],
  },
  {
    id: 3,
    title: "UX Designer",
    company: "ToDo",
    yearsActive: "May 2022 - Dec 2023",
    information: [
      "Designed an intuitive dashboard UI for a to-do application",
      "Focused on enhancing task management efficiency and user engagement",
      "Produced high-fidelity prototypes and collaborated on user testing",
    ],
  },
];

export default WorkExperience;
